import { L10n } from '@syncfusion/ej2-base';
import { ActionEventArgs, ColumnDirective, ColumnsDirective, DialogEventArgs, KanbanComponent } from '@syncfusion/ej2-react-kanban';
import { APITodoHelper } from '../../../Api/ApiTodoHelper';
import { TodoDTO, UpdateTodoKanbanDTO, DeleteTodoDTO } from '../../../Api/TodoMicroserviceClient';
import SingleTodoScene from './SingleTodoScene';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import DeleteDialog from '../../Shared/Layouts/DeleteDialog';
import { TodoChildProps } from './TodoChildProps';
import { useTranslation } from 'react-i18next';
import { useApi } from '../../../ApiOld/Api/useApi';
import { TodoListDTO, TodoMainVovClient, TodoState, UpdateTodoKanbanDto, UpdateTodoKanbanRequest } from '../../../ApiOld/Api/ApiServerVov';
import { useUserLayoutContext } from '../../../Contexts/Providers/UserLayoutMenuProvider';
import { StavarioModule } from '../../Shared/Layouts/StavarioModule';
import { Box, Button } from '@mui/material';

L10n.load({
    'cs': {
        'kanban': {
            'items': 'x úkol',
            'min': 'Min',
            'max': 'Max',
            'cardsSelected': 'Karta vybrána',
            'yes': 'Ano',
            'no': 'Ne',
            'close': 'Zavřít',
            'noCard': 'Žádné karty',
            'unassigned': 'Nepřiřazeno'
        }
    },
    'pl': {
        'kanban': {
            'items': 'x zadanie',
            'min': 'Min',
            'max': 'Max',
            'cardsSelected': 'Wybrana karta',
            'yes': 'Tak',
            'no': 'Nie',
            'close': 'Anulować',
            'noCard': 'Brak zadań',
            'unassigned': 'Nie przypisano'
        }
    },
    'sk': {
        'kanban': {
            'items': 'x úloha',
            'min': 'Min',
            'max': 'Max',
            'cardsSelected': 'Karta vybraná',
            'yes': 'Áno',
            'no': 'Nie',
            'close': 'Zavrieť',
            'noCard': 'Žiadne karty',
            'unassigned': 'Nepriradené'
        }
    }
});


export default function KanbanStavario(props: TodoChildProps) {
    const { authorizedApi } = useApi(TodoMainVovClient);
    const refreshTasks = React.useCallback(async () => {
        const result = await authorizedApi.getTodos();
        setData(result.todos ?? []);
        // setData(result);
        console.log('loading top');
        // stopLoading!();

    }, [authorizedApi]);
    const { setActiveModule, setMenuButtons } = useUserLayoutContext();
    useEffect(() => {

        setActiveModule(StavarioModule.TodoKanban);
    }, [setActiveModule]);
    useEffect(() => {

        setMenuButtons(<Box>
            <Button onClick={() => { setSwimlanesField(prev => prev === 'buildingName' ? 'responsiblePerson' : 'buildingName') }}>S</Button>
        </Box>)
    }, [setMenuButtons]);
    React.useEffect(() => {
        refreshTasks();
    }, [refreshTasks]);
    const [data, setData] = React.useState<TodoListDTO[]>([]);
    const { tasks, onRefreshData, onRefresh } = props;
    const { t, i18n } = useTranslation();
    console.log('jazyk kanban ', i18n.language);
    const [selectedTodo, setSelectedTodo] = useState<TodoDTO | undefined>();
    const [swimlanesField, setSwimlanesField] = useState<string>('buildingName');
    const [deleteData, setDeleteData] = useState<ActionEventArgs | null>(null);
    const [deleteDialogOpen, setDeleteDialogOpen] = React.useState(false);
    useEffect(() => {
        if (deleteData !== null)
            setDeleteDialogOpen(true);
    }, [deleteData]);
    useEffect(() => {
        if (selectedTodo !== null)
            setNewOpen(true);
    }, [selectedTodo]);
    function kanbanChanged(args: ActionEventArgs) {
        if (args.changedRecords && args.changedRecords.length > 0) {
            for (let item of args.changedRecords) {
                console.log(item);
            }
            // refKanban.current?.
            let kanbanChangedRecords = args.changedRecords!.map((item) => new UpdateTodoKanbanDto({
                id: item.id, state: Number(item.state) as TodoState, responsiblePersonId: item.responsiblePersonId ? Number(item.responsiblePersonId) : undefined,
                buildingId: item.buildingId ? Number(item.buildingId) : undefined
            }));
            authorizedApi.updateKanban(new UpdateTodoKanbanRequest({ updates: kanbanChangedRecords }));
            // console.log(kanbanChangedRecords, args.changedRecords);
            // if (onRefresh)
            //     onRefresh();

            // new APITodoHelper().UpdateKanbanTodos(kanbanChangedRecords);

        }
    }
    function kanbanDelete(args: any) {
        if ('cancel' in args && 'deletedRecords' in args) {
            new APITodoHelper().DeleteTodos(args.deletedRecords!.map((item: any) =>
                new DeleteTodoDTO({ id: item.id, timestamp: item.rowVersion })));
            setDeleteDialogOpen(false);
            setDeleteData(null);
        }
    }
    function kanbanDeleteQuestion(args: ActionEventArgs) {
        console.log(args);
        if (args.deletedRecords !== undefined && args.deletedRecords.length > 0) {
            args.cancel = true;
            setDeleteData(args);
        }
        // setDeleteDialogOpen(true);
    }
    function deleteDialogClose(e: any) {
        if ('cancel' in e) {
            // e.cancel = true;
            setDeleteDialogOpen(false);
            setDeleteData(null);
        }
    }
    function dialogOpen(e: DialogEventArgs) {
        e.cancel = true;
        setSelectedTodo(e.data as TodoDTO);
    }
    const getSwimlanesKeyField = useCallback(() => {
        if (swimlanesField === 'buildingName')
            return 'buildingId';
        else return 'responsiblePersonId';
    }, [swimlanesField]);
    function newProjectClosed() { setNewOpen(false); setSelectedTodo(undefined); }
    const [newOpen, setNewOpen] = useState(false);
    const refKanban = useRef<KanbanComponent>(null);
    return (<div>
        {data.length > 0 && <KanbanComponent dataSource={data} id="kanban"
            locale={i18n.language}
            ref={refKanban}
            height={'auto'}
            // height={'calc(100vh - 180px)'}
            width={'auto'}
            // width={'100vw'}

            actionComplete={kanbanChanged}
            actionBegin={kanbanDeleteQuestion}
            swimlaneSettings={{ keyField: getSwimlanesKeyField(), allowDragAndDrop: true, textField: swimlanesField }}
            dialogOpen={dialogOpen}
            keyField='state'
            dragStop={(e) => { e.cancel = false }}
            cardSettings={{ contentField: "buildingName", headerField: "name", selectionType: 'Single' }}>
            <ColumnsDirective>
                <ColumnDirective headerText={t('singleTodo.new')} keyField={0} />
                <ColumnDirective headerText={t('beingResolved')} keyField={1} />
                <ColumnDirective headerText={t('singleTodo.resolved')} keyField={2} />
            </ColumnsDirective>
        </KanbanComponent >}
        {/* <SingleTodoScene onRefresh={() => { if (onRefresh) onRefresh(); }} todo={selectedTodo} open={newOpen} selectedValue="nový úkol" onClose={newProjectClosed} /> */}
        <DeleteDialog onClose={deleteDialogClose} open={deleteDialogOpen} data={deleteData} onDeleteAgree={event => kanbanDelete(event)} />
    </div>);
}